import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../services/api/auth.service';

/**
 * Guard de sesión para rutas bajo /signin (excluyendo /signin/authorize)
 *
 * Comportamiento:
 * - Si existe sessionToken válido en memoria → permite navegación
 * - Si no existe o expiró → redirige a /signin/authorize.
 *
 * (La creación de sesión ocurre en /signin/authorize)
 */
export const sessionGuard: CanActivateFn = (route) => {
  const authService = inject(AuthService);
  const router = inject(Router);

  if (isSessionValid(authService)) {
    return true;
  }
  
  return router.createUrlTree(['/signin/authorize'], { queryParams: route.queryParams });
};

/**
 * Verifica si existe una sesión válida (no expirada) en memoria
 */
function isSessionValid(authService: AuthService): boolean {
  const token = authService.sessionToken();

  if (!token) {
    return false;
  }

  const payload = authService.decodeSessionToken(token);
  if (!payload?.exp) {
    return false;
  }

  return true;
}
